import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Briefing from './briefing';
import Privacidade from './Privacidade';
import ExclusaoDeDados from './ExclusaoDeDados';

// Volta ao topo ao trocar de rota (ex.: links do rodapé)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/briefing" element={<Briefing />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/exclusao-de-dados" element={<ExclusaoDeDados />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
